import Vue from 'vue'
import Router from 'vue-router'
import Demo from './views/Demo.vue'
import index from './views/index.vue'
//swiper 使用
import HelloWorld from '../src/components/HelloWorld'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      //测试 px--->转rem 的插件
      component: index
    },
    // {
    //   path: '/HelloWorld',
    //   name: 'HelloWorld',
    //   //测试 px--->转rem 的插件
    //   component: HelloWorld
    // },
  ]
})
